export const Themes = {
  LIGHT: "LIGHT",
  ONE_DARK: "ONE_DARK",
  UNICORN: "UNICORN",
};

export const horizontalGradient = "linear-gradient(270.72deg, #180255 0.25%, #000000 97.54%)";

export const verticalGradient = "linear-gradient(180.72deg, #180255 0.25%, #000000 97.54%)";
